/* 
    This class handles all actions related to users leveling up
*/

let levelUpConfig = [
    {
        level: 1,
        name: "Initiate",
        pointsNeeded: 0
    },
    {
        level: 2,
        name: "Novice",
        pointsNeeded: 1000
    },
    {
        level: 3,
        name: "Apprentice",
        pointsNeeded: 2500
    },
    {
        level: 4,
        name: "Devotee",
        pointsNeeded: 10000
    },
    {
        level: 5,
        name: "Buff",
        pointsNeeded: 20000
    },
    {
        level: 6,
        name: "Scholar",
        pointsNeeded: 40000
    },
    {
        level: 7,
        name: "Expert",
        pointsNeeded: 80000
    },
    {
        level: 8,
        name: "Genius",
        pointsNeeded: 150000
    },
    {
        level: 9,
        name: "Pro",
        pointsNeeded: 400000
    },
    {
        level: 10,
        name: "Master",
        pointsNeeded: 1000000
    },
    {
        level: 11,
        name: "Grand Master",
        pointsNeeded: 3000000
    },
    {
        level: 12,
        name: "Grand Master Elite",
        pointsNeeded: 7000000
    },
    {
        level: 13,
        name: "Supreme Legendary Grand Master",
        pointsNeeded: 10000000
    }
];

export default {
    getRankName(level) {
        let levelObject = levelUpConfig.find((x) => x.level === level);
        if (levelObject) {
            return levelObject.name;
        }
        // Unknown level (out of sync with the game) - show the highest known rank instead of crashing.
        return levelUpConfig[levelUpConfig.length - 1].name;
    }
};
